import { STORE_RESET_PASSWORD_TOKEN, SET_DARK_MODE } from "constants/app";
import { IMPERSONATE, STOP_IMPERSONATE } from "constants/users";

function getCookie(cookiename) {
  // Get name followed by anything except a semicolon
  const cookiestring = RegExp(`${cookiename}[^;]+`).exec(document.cookie);

  // Return everything after the equal sign, or an empty string if the cookie name not found
  const ret = decodeURIComponent(
    cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : ""
  );
  return ret;
}

export default (
  state = { darkMode: getCookie("darkMode") === "true" },
  action
) => {
  switch (action.type) {
    case STORE_RESET_PASSWORD_TOKEN:
      return { ...state, resetPasswordToken: action.token };
    case SET_DARK_MODE:
      return { ...state, darkMode: action.token };
    case IMPERSONATE:
      return { ...state, impersonate: action.user };
    case `${STOP_IMPERSONATE}_SUCCESS`:
      return { ...state, impersonate: undefined };
    default:
      return state;
  }
};
